import { Box, Divider, Flex } from "@chakra-ui/react";
import { Button, Button_T } from "@ui/components";

interface ReportCtaProps {
  content: string;
  buttons: Button_T[];
}

export const ReportCta = ({ content, buttons }: ReportCtaProps) => {
  const contentArray = content.split("\\n");
  return (
    <Flex as="section" justifyContent="center" mb={20}>
      <Box
        bgColor="blue.200"
        borderRadius="3xl"
        maxW="3xl"
        my={8}
        px={{
          base: 8,
          md: 16,
        }}
        py={8}
        textAlign="center"
        position="relative"
      >
        <Box fontWeight="medium" pb={5}>
          {contentArray.map((line, idx) => (
            <Box as={"span"} key={idx}>
              {line}
              <Divider pt={2} />
            </Box>
          ))}
        </Box>
        <Flex
          position={{
            md: "absolute",
          }}
          left={{
            md: "50%",
          }}
          transform={{
            md: "translate(-50%, 0)",
          }}
          columnGap={8}
          rowGap={3}
          flexDirection={{
            base: "column",
            md: "row",
          }}
          alignItems="center"
        >
          {buttons.map((btn, idx) => (
            <Button key={`report-cta-btn-${idx}`} {...btn} py={6} px={8} />
          ))}
        </Flex>
      </Box>
    </Flex>
  );
};
